import { ChakraProps, HStack, Text, ThemingProps, useColorModeValue } from "@chakra-ui/react";
import { useAppContext } from "../contexts/app";
import SandboxToggle from "../settings/sandbox";

export default function SandboxNavbar({ ...rest }: ChakraProps & ThemingProps<"Text">) {
  const { state } = useAppContext();
  const textColor = useColorModeValue("gray.900", "gray.100");
  const reloadData = () => {
    state.isLoaded = false;
  };
  return (
    <HStack>
      <Text mb={0} color={textColor} {...rest}>
        Sandbox
      </Text>
      <SandboxToggle minimized onToggle={reloadData} />
    </HStack>
  );
}
